// extracted by mini-css-extract-plugin
export default {"dropdownRoot":"Dropdown_dropdownRoot__JgAix","wide":"Dropdown_wide__6rNzV"};